import React from 'react';

import Nav from '../components/Nav';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Portfolio() {
  return (
    <>
        <Nav />
        <Header />
        <section class="wrapper inner-banner-wrapper testimonial-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <h2>Portfolio</h2>
              </div>
            </div>
          </div>
        </section>
        <section class="wrapper content-banner-wrapper text-center">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <h3>Visit Our Portfolio</h3>
              </div>
            </div>
          </div>
        </section>
        <section class="wrapper filter-nav">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <ul id="filters">
                  <li><span class="filter active" data-filter="all">All Category</span></li>
                  <li><span class="filter" data-filter=".category-20">Code Igniter </span></li>
                  <li><span class="filter" data-filter=".category-18">OpenCart</span></li>
                  <li><span class="filter" data-filter=".category-25">WordPress</span></li>
                  <li><span class="filter" data-filter=".category-33">E-Commerce</span></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section class="wrapper custom-wrapper page-wrapper">
          <div class="container">
            <div class="row" id="portfoliolist">
              <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12 category-20" data-cat="category-20">
                <div class="product-thumb transition">
                  <div class="image"><img class="img-responsive" alt="" src="https://www.technowebsol.com/image/cache/catalog/PortFolio/searchslide-700x378.jpg" /> </div>
                  <div class="caption">
                    <h4>SearchSlide</h4>
                    <p>PHP, MySql, Various Search API<br />
                    </p>
                    <a target="_blank" href="http://searchslide.co.uk" class="goto-link"><i class="fa fa-link"></i></a> </div>
                </div>
              </div>
              <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12 category-20" data-cat="category-20">
                <div class="product-thumb transition">
                  <div class="image"><img class="img-responsive" alt="" src="https://www.technowebsol.com/image/cache/catalog/PortFolio/uneke-mobile-cases-700x378.jpg" /> </div>
                  <div class="caption">
                    <h4>Uneke Cases</h4>
                    <p>PHP, MySql, OpenCart<br />
                    </p>
                    <a target="_blank" href="http://unekecase-new.twsserver.com" class="goto-link"><i class="fa fa-link"></i></a> </div>
                </div>
              </div>
              <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12 category-18" data-cat="category-18">
                <div class="product-thumb transition">
                  <div class="image"><img class="img-responsive" alt="" src="https://www.technowebsol.com/image/cache/catalog/PortFolio/birwazy-700x378.jpg" /> </div>
                  <div class="caption">
                    <h4>BirWazy</h4>
                    <p>PHP, MySql<br />
                    </p>
                    <a target="_blank" href="http://www.birwazy.com" class="goto-link"><i class="fa fa-link"></i></a> </div>
                </div>
              </div>
              <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12 category-33" data-cat="category-33">
                <div class="product-thumb transition">
                  <div class="image"><img class="img-responsive" alt="" src="https://www.technowebsol.com/image/cache/catalog/PortFolio/fitness-deal-700x378.jpg" /> </div>
                  <div class="caption">
                    <h4>Fitness Deals</h4>
                    <p>PHP, MySql, OpenCart<br />
                    </p>
                    <a target="_blank" href="http://fitnessdeal.no" class="goto-link"><i class="fa fa-link"></i></a> </div>
                </div>
              </div>
              <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12 category-18" data-cat="category-18">
                <div class="product-thumb transition">
                  <div class="image"><img class="img-responsive" alt="" src="https://www.technowebsol.com/image/cache/catalog/PortFolio/scorpioncontroller-700x378.jpg" /> </div>
                  <div class="caption">
                    <h4>ScorpionController</h4>
                    <p>PHP, MySql, OpenCart<br />
                    </p>
                    <a target="_blank" href="http://www.scorpioncontrollers.com" class="goto-link"><i class="fa fa-link"></i></a> </div>
                </div>
              </div>
              <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12 category-18" data-cat="category-18">
                <div class="product-thumb transition">
                  <div class="image"><img class="img-responsive" alt="" src="https://www.technowebsol.com/image/cache/catalog/PortFolio/scorpiondrone-700x378.jpg" /> </div>
                  <div class="caption">
                    <h4>ScorpionDrones</h4>
                    <p>PHP, MySql, OpenCart<br />
                    </p>
                    <a target="_blank" href="http://www.scorpiondrones.com" class="goto-link"><i class="fa fa-link"></i></a> </div>
                </div>
              </div>
              <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12 category-25" data-cat="category-25">
                <div class="product-thumb transition">
                  <div class="image"><img class="img-responsive" alt="" src="https://www.technowebsol.com/image/cache/catalog/PortFolio/gombay-bm-700x378.jpg" /> </div>
                  <div class="caption">
                    <h4>Gombay</h4>
                    <p>PHP, MySql, WordPress<br />
                    </p>
                    <a target="_blank" href="https://www.gombay.bm" class="goto-link"><i class="fa fa-link"></i></a> </div>
                </div>
              </div>
              <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12 category-25" data-cat="category-25">
                <div class="product-thumb transition">
                  <div class="image"><img class="img-responsive" alt="" src="https://www.technowebsol.com/image/cache/catalog/PortFolio/futurite-in-700x378.jpg" /> </div>
                  <div class="caption">
                    <h4>Futurite</h4>
                    <p>
                    <p>PHP, MySql, WordPress</p>
                    </p>
                    <a target="_blank" href="http://www.futurite.in/" class="goto-link"><i class="fa fa-link"></i></a> </div>
                </div>
              </div>
              <div class="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12 category-33" data-cat="category-33">
                <div class="product-thumb transition">
                  <div class="image"><img class="img-responsive" alt="" src="https://www.technowebsol.com/image/cache/catalog/PortFolio/abhijanbooks-700x378.png" /> </div>
                  <div class="caption">
                    <h4>Abhijan Books</h4>
                    <p>
                    <p>PHP, MySql, Codeigniter</p>
                    </p>
                    <a target="_blank" href="https://abhijanbooks.com/" class="goto-link"><i class="fa fa-link"></i></a> </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
    </>
  )
}

export default Portfolio